/* global angular, _ */

var ngModule = angular.module('trends');

ngModule.directive('trPagination', ['Monitor', '$q',
    function (Monitor, $q) {
        return {
            restrict: 'AEC',
            scope: {pages: '=', arg: '=', onPageChanged: '=', numPages: '&', pageRange: '='},
            templateUrl: '/trends/partials/pagination/',
            link: function (scope) {
                scope.loader = new Monitor();

                /* Reset the component to its initial state. */
                scope.reset = function () {
                    scope.loading = -1; // Page index of page requested to be loaded
                    scope.page = 0;
                    scope.loader.reset();
                };

                /* Attempt to change the active page. The `onPageChanged` callback is
                   passed the destination page, a deferred to resolve if allowed,
                   and the content of `arg`.

                   The deferred must be resolved or rejected by the callback with the
                   actual page to display.*/
                scope.setPage = function (index) {
                    if (!scope.canMove(index - scope.page) || scope.isLoading(index)) {
                        return;
                    }
                    var deferred = $q.defer();

                    scope.loading = index;
                    scope.loader.watch(deferred.promise.then(function (index) {
                        scope.page = index;
                        scope.loading = -1;
                    }));

                    scope.onPageChanged(index, deferred, scope.arg);
                };

                /* Move from the current page in a direction. Does nothing if the move
                   is not allowed. */
                scope.move = function (dir) {
                    var target = scope.page + dir;
                    scope.setPage(target);
                };

                /* Jump to the page list in direction `dir` using `move`. */
                scope.jump = function (dir) {
                    scope.move(getJumpDelta(dir));
                };

                /* Check if the page in direction `dir` can be moved to. */
                scope.canMove = function (dir) {
                    var target = scope.page + dir;
                    return /*!scope.loader.isBusy() &&*/ target >= 0 && target < scope.numPages();
                };

                /* Check if the page list in direction `dir` can be moved to. */
                scope.canJump = function (dir) {
                    return scope.canMove(getJumpDelta(dir));
                };

                /* Check if `page` has been clicked on to be loaded. */
                scope.isLoading = function (page) {
                    return scope.loading === page;
                };

                /* Get the vector from the current position to the start of the page list
                   in direction `dir`. */
                var getJumpDelta = function (dir) {
                    return scope.getJumpTarget(dir) - scope.page;
                };

                /* Get the page which will be jumped to if jumping in direction `dir`. */
                scope.getJumpTarget = function (dir) {
                    return getPageListStart(scope.page + (dir * scope.pageRange));
                };

                /* Get the starting page of the page list which contains `pageN`. */
                var getPageListStart = function (pageN) {
                    return Math.floor(pageN / scope.pageRange) * scope.pageRange;
                };

                /* Return an array containing the visible page list. */
                scope.pageList = function () {
                    var max = scope.numPages();
                    var start = getPageListStart(scope.page);
                    var end = start + scope.pageRange;

                    var overflow = end - max;
                    if (overflow > 0) {
                        end = max;
                    }

                    return _.range(start, end);
                };

                scope.reset();
            }
        };
    }]);
